/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export default class WorkflowsTroubleshootConversationEventsRoute extends ReactRoute(Route) {
  reactEnabled(): boolean {
    return true;
  }
}
